import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldHalved, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

export default function ForbiddenPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6">
      <div className="max-w-md text-center space-y-6">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-amber-100">
          <FontAwesomeIcon icon={faShieldHalved} className="w-10 h-10 text-amber-600" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-stone-900">Access Denied</h1>
          <p className="mt-2 text-stone-500">
            You don't have permission to view this page. Contact your organization administrator
            if you believe you should have access.
          </p>
        </div>
        <Link
          to="/dashboard"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-primary-600 text-white hover:bg-primary-700 transition"
        >
          <FontAwesomeIcon icon={faArrowLeft} className="w-4 h-4" />
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
